<template>
  <v-list-tile>
    <v-list-tile-avatar>
      <v-icon>person_outline</v-icon>
    </v-list-tile-avatar>

    <v-list-tile-content>
      <v-list-tile-title>{{ guest.nombre }} {{ guest.apellido }}</v-list-tile-title>
      <v-list-tile-sub-title>{{ guest.email }}</v-list-tile-sub-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
export default {
  props: {
    guest: Object
  }
}
</script>
